import { wallClock } from './format';

export interface DayGroup<T> {
  key: string;
  date: Date;
  items: T[];
}

/** Consecutive items with the same local calendar day of `dateOf` (capture date by default; input is sorted). */
export function groupByDay<T extends { takenAt: string }>(items: readonly T[], dateOf: (it: T) => string = (it) => it.takenAt): DayGroup<T>[] {
  const groups: DayGroup<T>[] = [];
  for (const it of items) {
    const d = wallClock(dateOf(it));
    const key = d.toDateString();
    const last = groups[groups.length - 1];
    if (last && last.key === key) last.items.push(it);
    else groups.push({ key, date: d, items: [it] });
  }
  return groups;
}
